import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useSelector } from 'react-redux';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import { PageContainer } from '@/components/containers/PageContainer/PageContainer';
import Label from '@/components/form/Label/Label';
import './CancelationPolicies.scss';

const CancelationPoliciesView = (props) => {
  const { spacesData } = props;
  const lenguageData = useSelector((state) => state.lenguage.lang);
  const esDescription =
    'Al reservar en Popnest, aceptas nuestras normas de uso, pago y cancelación. Respetamos tu privacidad y te pedimos cuidar el espacio y a otros usuarios. Consulta nuestros términos para más detalles.';
  const enDescription =
    'By booking with Popnest, you agree to our usage, payment, and cancellation policies. We respect your privacy and ask you to care for the space and other users. Check our terms for more details.';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <PageContainer className={'termsView flex-column margtb80'}>
      <HelmetComponent
        title={
          lenguageData === 'EN'
            ? 'Terms and Conditions - Popnest'
            : 'Terminos y Condiciones - Popnest'
        }
        description={lenguageData === 'EN' ? enDescription : esDescription}
        graphTitle={
          lenguageData === 'EN'
            ? 'Terms and Conditions - Popnest'
            : 'Terminos y Condiciones - Popnest'
        }
        graphDescription={lenguageData === 'EN' ? enDescription : esDescription}
      />
      <Label className={'text-12 m-text-10'}>
        <section>
          <h3>
            <strong style={{ fontWeight: 700 }}>CANCELLATION AND RESERVATION REFUND POLICY</strong>
          </h3>
          <p className={'text-16'}>
            The HOST agrees to issue refunds for accommodation payments according to the following
            terms:
          </p>

          <ul>
            <li>
              To receive a <strong style={{ fontWeight: 700 }}>90%</strong> refund, the USER must
              cancel at least <strong style={{ fontWeight: 700 }}>30 calendar days</strong> prior to
              the reservation start date. Otherwise, the HOST is not obligated to refund the
              payment.
            </li>
            <li>
              To receive a <strong style={{ fontWeight: 700 }}>70%</strong> refund, the USER must
              cancel between <strong style={{ fontWeight: 700 }}>29 and 15 calendar days</strong>{' '}
              prior to the reservation start date. Otherwise, the HOST is not obligated to refund
              the payment.
            </li>
            <li>
              To receive a <strong style={{ fontWeight: 700 }}>50%</strong> refund, the USER must
              cancel between <strong style={{ fontWeight: 700 }}>14 and 10 calendar days</strong>{' '}
              prior to the reservation start date. Otherwise, the HOST is not obligated to refund
              the payment.
            </li>
            <li>
              <strong style={{ fontWeight: 700 }}>No refunds</strong> apply if the USER cancels within{' '}
              <strong style={{ fontWeight: 700 }}>9 calendar days or less</strong> before the
              reservation start date.
            </li>
          </ul>

          <table border="1" cellpadding="5" cellspacing="0">
            <thead>
              <tr>
                <th>Days Prior to Reservation</th>
                <th>Refund Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Up to 30 days</td>
                <td>90%</td>
              </tr>
              <tr>
                <td>29 to 15 days</td>
                <td>70%</td>
              </tr>
              <tr>
                <td>14 to 10 days</td>
                <td>50%</td>
              </tr>
              <tr>
                <td>9 days or less</td>
                <td>No refund</td>
              </tr>
            </tbody>
          </table>

          <p className={'text-16'}>
            “Day 0” refers to the day the HOST makes the space available for use. “Day 1” refers to
            the day before the reservation begins. In the event the reservation cannot take place
            due to force majeure or unforeseen circumstances, the HOST agrees to either: (i) issue a
            full refund or (ii) reschedule the reservation to a new date, subject to availability.
          </p>
          <p className={'text-16'}>
            POPNEST commits to offering flexibility when rescheduling or changing spaces is
            feasible, ensuring a reservation experience that meets the HOST’s preferences and needs.
          </p>
        </section>

        <section>
          <h3>
            <strong style={{ fontWeight: 700 }}>HOST RESPONSIBILITY POLICY</strong>
          </h3>
          <p className={'text-16'}>
            The HOST is responsible for their actions and omissions within the provided space. The
            HOST agrees to:
          </p>
          <ul>
            <li>(i) verify that the USER checks in and out at the agreed times,</li>
            <li>(ii) ensure the USER leaves the space in the same condition as they found it,</li>
            <li>
              (iii) request compensation from the USER for any damages caused by them, their guests,
              or pets,
            </li>
            <li>(iv) maintain professional and lawful conduct at all times,</li>
            <li>(v) maintain open communication with the USER and POPNEST.</li>
          </ul>
        </section>

        <section>
          <h3>
            <strong style={{ fontWeight: 700 }}>PAYMENT</strong>
          </h3>
          <p className={'text-16'}>
            All payments to HOSTS will be made via the Stripe platform. The HOST must complete the
            Stripe onboarding process, which includes providing a designated bank account to receive
            payments from POPNEST.
          </p>
          <p className={'text-16'}>
            POPNEST manages payments through its Stripe account and transfers funds securely and
            efficiently to the HOST’s Stripe account. This ensures a reliable and seamless financial
            transaction between POPNEST and the HOST.
          </p>
          <p className={'text-16'}>
            The HOST consents to having their banking information collected by Stripe for payment
            purposes. For more details, please refer to:
            <a href="https://stripe.com/docs/connect/add-and-pay-out-guide" target="_blank">
              Stripe Documentation
            </a>
          </p>
        </section>

        <section>
          <h3>
            <strong style={{ fontWeight: 700 }}>QUESTIONS, CLAIMS, OR CLARIFICATIONS</strong>
          </h3>
          <p className={'text-16'}>
            The HOST may direct any questions, complaints, or clarifications to POPNEST via email
            at:
            <a href="mailto:soporte@popnest.co">soporte@popnest.co</a>
          </p>
        </section>

        <section>
          <h3>
            <strong style={{ fontWeight: 700 }}>HOST SUPPORT</strong>
          </h3>
          <p className={'text-16'}>
            POPNEST offers HOST support through the same email:
            <a href="mailto:soporte@popnest.co">soporte@popnest.co</a>, where they can contact the
            Customer Support team for any issues related to the use of the WEBSITE or reservation
            services.
          </p>
        </section>
      </Label>
    </PageContainer>
  );
};

export default CancelationPoliciesView;
